import { useNavigate } from "react-router-dom";
import UserLogo from "../../assets/Images/useravatar.jpg";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { Avatar } from "@progress/kendo-react-layout";
import { RiLockPasswordLine, RiLogoutCircleRLine, RiSettings4Line } from "react-icons/ri";
import React from "react";
import IconComponent from "../common/IconComponent";
import { openDialog } from "../dialog/dialogSlice";

const UserProfile = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const loginDetails = useAppSelector((state) => state.login.loginDetails);
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const handleMenuClick = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const FBTOKEN = localStorage.getItem("FBTOKEN");
  const FBUserID = localStorage.getItem("FBUserID");

  const handleLogout = () => {
    localStorage.clear();
    if (FBTOKEN !== null) {
      localStorage.setItem("FBTOKEN", FBTOKEN);
    }
    if (FBUserID !== null) {
      localStorage.setItem("FBUserID", FBUserID);
    }
    navigate("/login");
    setIsMenuOpen(false);
  };
  const handleChangePassword = () => {
    setIsMenuOpen(false);
    dispatch(openDialog("changePassword"));
  };
  const handleSoftwareSetting = () => {
    setIsMenuOpen(false);
    dispatch(openDialog("softwareSettings"));
  };

  React.useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (!event.target.closest(".userprofile")) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  return (
    <div className="userprofile position-relative" onClick={handleMenuClick}>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <div
          style={{
            display: "flex",
            alignItems: "end",
            flexDirection: "column",
            color: "#fff",
          }}
        >
          <strong>{loginDetails?.FullName || ""}</strong>
          <strong style={{ fontSize: 14, fontWeight: 600 }}>
            {loginDetails?.UserType || ""}
          </strong>
        </div>
        <Avatar
          className="userprofile-avatar"
          type="image"
          size="medium"
          style={{ width: 40, height: 40, borderRadius: "50%", flex: 1 }}
        >
          <img
            src={
              // loginDetails?.UserImage && loginDetails?.UserImage !== "null"
              //   ? loginDetails?.UserImage
              //   :
              UserLogo
            }
            alt={`user image`}
            style={{
              width: "100%",
              height: "100%",
              borderRadius: "50%",
            }}
          />
        </Avatar>

        {/* <Avatar size={40} gap={0} icon={} /> */}
      </div>
      {isMenuOpen && (
        <div className="userprofile-dropdown">
          <ul>
            <li onClick={handleChangePassword}>
              <IconComponent icon={RiLockPasswordLine} /> &nbsp;Change Password
            </li>
            <li onClick={handleSoftwareSetting}>
              <IconComponent icon={RiSettings4Line} /> &nbsp;Software Setting
            </li>
            <li onClick={handleLogout} style={{ color: "red" }}>
              <IconComponent icon={RiLogoutCircleRLine} /> &nbsp;Log Out
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default UserProfile;
